export default "https://legacy.eskolare-development.com/images/location.png";